import Header from '../../components/Header'
import HeaderImage from '../../img/olivier3.jpg'
import Card from '../../UI/Card'
import {plans} from '../../data'
import './plans.css'
const Plans = () => {
    return (
        <>
            < Header title="Services & Formations" image={HeaderImage} >
                Découvrez nos services et formations de qualité qui répondent à vos besoins. Nous offrons une gamme complète de services dans différents domaines, allant de la formation professionnelle au développement de logiciels en passant par la consultation et bien plus encore. Notre équipe d'experts qualifiés est là pour vous accompagner à chaque étape, en vous fournissant les connaissances, les compétences et le soutien nécessaires pour atteindre vos objectifs. Que vous soyez une entreprise à la recherche de solutions personnalisées ou un individu souhaitant développer ses compétences, nous avons ce qu'il vous faut. Explorez nos services et formations dès aujourd'hui et laissez-nous vous aider à réussir.
            </Header >
            <section className="plans">
                    <div className="container plans__container">
                      {
                        plans.map(({id,name, desc, price, features})=>{
                            return<Card key={id} className="plan" >
                                <h3> {name} </h3>
                                <small> {desc} </small>
                                <h1> {`${price}F ` } </h1>
                                <h4> Modules </h4>
                                {
                                    features.map(({ feature, available }, index)  =>{
                                        return <p key={index} className={!available ? "disabled" :""  } >
                                                {feature}
                                        </p>

                                    })
                                }
                                <button className='btn lg' > Brochure </button>
                                </Card>
                        })
                      }
                    </div>
            </section>
            </>
        
    )
}

export default Plans


